import { Link } from "@mui/material";
import style from "./Footer.module.css";
const leftText = "Affida S.r.l.® OAM n.M325 - C.F. e P.iva 06514480729";
const rightText =
  "Via Lucrezio Caro n. 62, 00193 Roma, Capitale sociale €62.500,00";
export const Footer = () => {
  return (
    <div className={`${style.footerContainer}`}>
      <div className={`container`} style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly"
      }}>
          <div>{leftText}</div>
          <div className={"flex-row gap-2"}>
            <Link
              target={"_blank"}
              href="https://www.affida.credit/pagine/privacy-policy"
            >
              Privacy
            </Link>
            <Link
              target={"_blank"}
              href="https://www.iubenda.com/privacy-policy/85939233/cookie-policy"
            >
              Cookie Policy
            </Link>
          </div>
          <div>{rightText}</div>
      </div>
    </div>
  );
};
